import React from 'react';
import styled from 'styled-components';

const Animacion = styled.img`
    margin-bottom: 15px;
`;

const Spinner = () => {
    return (
        
            <div>
                <Animacion src="https://www.gifsanimados.org/data/media/710/dado-imagen-animada-0020.gif" border="0" alt="dado-imagen-animada-0020" />
            </div>
        
    )
}

export default Spinner;